import {
  FilterMode,
  CreditMovement_OrderBy,
  CreditMovement,
  SortOrder,
  CreditMovement_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";

export const creditMovementService = {
  createOne: () => (): Promise<string> => new Promise(() => ""),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.creditMovementOne({ id });
    return result.creditMovementOne as CreditMovement;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: CreditMovement_OrderBy[] | null = null,
    filter: CreditMovement_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: CreditMovement_Filter | undefined;
    if (searchValue !== "") {
      where = {
        detail: { contains: searchValue, mode: FilterMode.Insensitive },
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.creditMovementListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : [{ detail: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.creditMovementListWithOffset
    ) as CreditMovement[];
    return { list, orderBy };
  },
};
